import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useLoadRequirement} from '../hooks';
import IntegrityRequirementGrid from './IntegrityRequirementGrid';

const RequirementGrid = () => {
  const loadRequi = useLoadRequirement();
  return (
    <IntegrityRoleGrid
      allowEdit={[Roles.AdminQA, Roles.AdminHSE]}
      dataSource={loadRequi}
      id={['iD_Course', 'iD_Sector', 'iD_Profile']}
      integrityGrid={IntegrityRequirementGrid}
      integrityId={['ID_Course', 'ID_Sector', 'ID_Profile']}
      integrityName={'Requirement'}
      allowActions={false}
      exportName="Requirement-export">
      <Column
        caption={i18n2._('#Curso')}
        visible={false}
        dataField="iD_Course"
      />
      <Column
        caption={i18n2._('#Perfil')}
        visible={false}
        dataField="iD_Profile"
      />
      <Column
        caption={i18n2._('#Sector')}
        visible={false}
        dataField="iD_Sector"
      />
      <Column
        caption={i18n2._('Sector')}
        dataField="sector_Name"
        width="8%"
        defaultSortOrder={'asc'}
      />
      <Column
        caption={i18n2._('Perfil')}
        dataField="profile_Name"
        width="13%"
      />
      <Column
        caption={i18n2._('Documento')}
        dataField="doc_Number"
        width="10%"
      />
      <Column caption={i18n2._('Curso')} dataField="course_Name" width="50%" />
      <Column caption={i18n2._('Motivo')} dataField="reason" width="10%" />
      <Column
        caption={i18n2._('Fecha de Requerimiento')}
        dataField="req_Date"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.req_Date)}
        width="10%"
      />
      <Column
        caption={i18n2._('Version')}
        dataField="version"
        visible={false}
      />
      <Column
        caption={i18n2._('Revision')}
        dataField="revision"
        visible={false}
      />

      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
        width="10%"
      />
      <Column
        caption={i18n2._('Actualizado por')}
        dataField="updatedBy"
        visible={false}
      />
      <Column
        caption={i18n2._('Eliminado')}
        dataField="deleted"
        width={100}
        visible={false}
      />
    </IntegrityRoleGrid>
  );
};

export default RequirementGrid;
